export const popWinConfig = {
  "dataFromDesc": {
      "title": "数据说明",
      "content": [
          "重要说明：随着对新型冠状病毒肺炎认识的深入和诊疗经验的积累，针对湖北省疫情特点，国家卫生健康委办公厅、国家中医药管理局办公室印发的《新型冠状病毒感染的肺炎诊疗方案（试行第五版）》在湖北省的病例诊断分类中增加了“临床诊断”，以便患者能及早按照确诊病例接受规范治疗，进一步提高救治成功率。根据该方案，近期湖北省对既往的疑似病例开展了排查并对诊断结果进行了订正，对新就诊患者按照新的诊断分类进行诊断。为与全国其他省份对外发布的病例诊断分类一致，从2月13日起，湖北省将临床诊断病例数纳入确诊病例数进行公布，因此新增确诊数据会有较大波动。",
          "----",
          "数据来源：全部数据来源于国家卫健委、各省市、自治区卫健委、各省市区政府以及港澳台官方渠道。",
          "实时数据方面，腾讯健康的统计方法如下：",
          "1、全国实时数据",
          "1）全国累计确诊/治愈/死亡（包含港澳台）：当国家卫健委未公布数据时，该数据为各地实时数据之和；当国家卫健委公布数据后，取国家卫健委公布的数据；各地卫健委陆续公布数据，如果各地实时数据总和已经超过之前国家卫健委总数，则直接使用各地实时数据总和作为全国总数。",
          "2）全国现有疑似（不包含港澳台）：使用国家卫健委公布的全国疑似数据，当国家卫健委未公布数据时，使用前一天国家卫健委公布的数据。该数据不会随着实时数据增加而改变；",
          "3）全国昨日新增确诊/疑似/治愈/死亡（包含港澳台）：该数据与国家卫健委公布的数据一致，不会随着实时数据增加而改变。若国家卫健委未公布当天数据，数据项不展示。",
          "4）全国昨日新增疑似（不包含港澳台）：该数据与国家卫健委公布的数据一致，不会随着实时数据增加而改变。若国家卫健委未公布当天数据，数据项不展示。",
          "2、湖北省外实时数据",
          "1）湖北省外累计确诊/治愈/死亡（包含港澳台）：取当前全国实时累计数据减去湖北省实时累计数据。",
          "2）湖北省外现有疑似（不包含港澳台）：取国家卫健委公布的全国现有疑似数据减去湖北省卫健委公布的现有疑似数据，该数据不会随着实时数据增加而改变。当国家或湖北省卫健委未公布数据时，该数据项展示“待更新”。",
          "3）湖北省外昨日新增确诊/治愈/死亡（包含港澳台）：取国家卫健委公布的新增数据减去湖北省卫健委公布的新增数据，该数据不会随着实时数据增加而改变。若国家卫健委或湖北卫健委未公布昨日数据，数据项不展示；",
          "4）湖北省外昨日新增疑似（不包含港澳台）：取国家卫健委公布的全国新增疑似减去湖北省的新增疑似数，该数据不会随着实时数据增加而改变。若国家卫健委未公布湖北省的新增疑似数，数据项展示“-”；",
          "",
          "疫情趋势图方面，腾讯健康的统计方法如下：",
          "1. 全国疫情每日新增病例走势图、全国疫情累计病例走势图、全国疫情每日新增重症/治愈/死亡病例走势图：该数据使用国家卫健委公布数据，每天更新一次。除最近一个日期的新增确诊/死亡、累计确诊/死亡包含全国数据，其余日期和数据项均只包含31个省（自治区、直辖市）和新疆生产建设兵团，不包含港澳台地区数据；",
          "2. 新增确诊病例走势图、在治重症病例走势图、累计死亡病例走势图、新增治愈与死亡病例走势图：该数据使用国家和各地卫健委公布数据，每天更新一次。其中湖北省外数据，除最近一个日期的新增确诊/死亡、累计死亡包含全国数据，其余日期和数据项均只包含31个省（自治区、直辖市）和新疆生产建设兵团，不包含港澳台地区数据；",
          "",
          "治愈率、病死率、重症率方面，腾讯健康的统计方法如下：",
          "1. 治愈率：当前卫健委公布的已治愈出院病例数量占累计报告确诊病例的比例，反应了感染新型冠状病毒病例可治愈的概率",
          "2. 重症率：当前卫健委公布的因感染新型冠状病毒确诊的病例中，在治重症病例数量占在治病例总数量的比例",
          "3. 病死率：当前卫健委公布的因感染新型冠状病毒死亡的病例数量占累计报告确诊病例的比例，说明疾病的严重程度",
          "",
          "腾讯健康·腾讯新闻联合团队全体全力以赴努力做好，欢迎大家在发现相关数据错误时及时联系我们。反馈入口：进入微信搜索“腾讯健康”微信公众号，直接留言反馈，或搜索“腾讯新闻APP”微信公众号，直接留言反馈即可。"
      ]
  },
  "suspectDesc": {
    "show": true,
    "isLink": false,
    "link": {
      "desc": "",
      "url": ""
    },
    "title": "数据说明",
    "content": [
        "数据使用国家卫健委公布的“新增疑似病例数”。"
    ]
  },
  "noinfectDesc": {
    "show": true,
    "isLink": false,
    "link": {
      "desc": "",
      "url": ""
    },
    "title": "数据说明",
    "content": [
        "无症状感染者数（不含港澳台）：取国家卫健委公布的尚在医学观察无症状感染病者数；",
        "“昨日+”：取国家卫健委公布的昨日新增无症状感染者数；"
    ]
  },
  "nowConfirmDesc": {
    "show": true,
    "isLink": false,
    "link": {
      "desc": "",
      "url": ""
    },
    "title": "数据说明",
    "content": [
      "全国现有确诊（包含港澳台）：该数据取当前全国的累计确诊数减去累计治愈和累计死亡数。"
    ]
  },
  "microTrendDesc": {
      "title": "数据说明",
      "content": [
          "疫情微趋势中图表均为趋势示意图，不代表疫情对应数据的绝对值。",
          "相关数据来源于计算方法如下。",
          "【 数据来源 】 国家、地区卫健委官方发布疫情数据。",
          "【 计算方法＆曲线说明 】",
          "更新时间: 为微趋势后台计算时间，不代表国家、地区卫健委官方发布数据时间。",
          "近7日增长率： [（最新已公布对应数据 一 7 天前公布对应数据） / 7 天前公布对应数据] ＊ 100 %",
          "新增确诊病例趋势曲线：纵坐标为对数增长，仅用作表现趋势，不代表数据绝对值。",
          "新增疑似病例趋势曲线：纵坐标为线性增长，仅用作表现趋势，不代表数据绝对值。",
          "新增治愈病例趋势曲线：纵坐标为线性增长，仅用作表现趋势，不代表数据绝对值。",
          "新增死亡病例趋势曲线：纵坐标为对数增长，仅用作表现趋势，不代表数据绝对值。"
      ]
  },
  "heavyRateDesc": {
      "title": "数据说明",
      "content": [
          "重症率：当前国家卫健委公布的因感染新型冠状病毒确诊的病例中，在治重症病例数量占在治病例总数量的比例"
      ]
  },
  "deadRateDesc": {
      "title": "数据说明",
      "content": [
          "病死率：当前国家卫健委公布的因感染新型冠状病毒死亡的病例数量占总确诊病例的比例，说明疾病的严重程度"
      ]
  },
  "addConfirmDesc": {
      "show": false,
      "isLink": false,
      "link": {
        "desc": "点击查看详细解读",
        "url": "https://h5.baike.qq.com/mobile/article.html?docid"
      },
      "title": "数据说明",
      "content": [
          "湖北部分城市存在核减，湖北省新增确诊数小于武汉市新增确诊数"
      ]
  },
  "addConfirmTrendDesc": {
      "title": "数据说明",
      "content": [
          "在《新型冠状病毒感染的肺炎诊疗方案（试行第五版）》中，诊断标准区分了湖北省以外和湖北省两种情况。",
          "湖北省在原来的“确诊病例”基础上，增加了“临床诊断病例”。新冠肺炎确诊病例，需要核酸检测阳性。然而，核酸检测的阳性率仅在30～50%之间，会导致一些真正的感染者被漏掉。临床诊断病例，可以将某些核酸检测阴性的新冠肺炎病例包括进来，以便患者能及早按照确诊病例接受规范治疗，进一步提高救治成功率。",
          "湖北省卫健委发文，近期对既往的疑似病例开展了排查并对诊断结果进行了订正，从2月13日起，湖北省将临床诊断病例数纳入确诊病例数进行公布，因此新增确诊数据会有较大波动"
      ]
  },
  "areaDetailDesc": {
    "show": false,
    "isLink": false,
    "link": {
      "desc": "点击查看详细解读",
      "url": "https://h5.baike.qq.com/mobile/article.html?docid"
    },
    "title": "数据说明",
      "content": [
        "湖北部分城市存在核减，湖北省新增确诊数小于武汉市新增确诊数"
      ]
  },
  "addConfirmCaseDesc": {
      "show": false,
      "isLink": false,
      "link": {
        "desc": "点击查看详细解读",
        "url": "https://h5.baike.qq.com/mobile/article.html?docid"
      },
      "title": "数据说明",
      "content": [
          "湖北部分城市存在核减，湖北省新增确诊数小于武汉市新增确诊数"
      ]
  },
  "otherSuspectDesc": {
      "title": "数据说明",
      "content": [
          "现有疑似：使用今日国家卫健委公布的全国现有疑似减去今日湖北省卫健委公布的现有疑似",
          "新增疑似：使用今日国家卫健委公布的全国新增疑似减去湖北省的新增疑似",
          "该数据需国家卫健委和湖北省卫健委都公布数据后更新。"
      ]
  }
}
